import { FC, HTMLProps, memo, ReactNode } from 'react';
import cx from 'classnames';

import styles from './Toast.module.scss';

export type ToastProps = Pick<HTMLProps<HTMLDivElement>, 'className' | 'onClick'> & {
  icon?: ReactNode;
};

const Toast: FC<ToastProps> = ({ children, icon, ...htmlProps }): JSX.Element => (
  <div {...htmlProps} className={cx(styles.container, htmlProps.className)}>
    {icon && <div className={styles.icon}>{icon}</div>}
    <div className={styles.content}>{children}</div>
  </div>
);

export const MemoizedToast = memo(Toast);
export default Toast;
